export const buildCancelBookingRequest = ({ hash, internal = 0, language, email }) => ({
  booking_hash: hash,
  internal,
  language,
  user_email: email,
})
